export const styles = {
  /* -------- Page shell -------- */
  container: {
    minHeight: "100vh",
    background:
      "radial-gradient(1100px 360px at 50% -10%, #f6faff 12%, transparent 68%)," +
      "radial-gradient(900px 240px at 100% -10%, #f3f4ff 10%, transparent 60%)",
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    color: "#0f172a",
  },

  /* keep these for loading/error states */
  loadingContainer: { minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, padding: 24 },
  loadingSpinner: { width: 40, height: 40, border: "3px solid #e5e7eb", borderTop: "3px solid #2563eb", borderRadius: "50%", animation: "spin 1s linear infinite" },
  errorContainer: { minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12, padding: 16 },
  errorCard: { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: 28, maxWidth: 420, width: "100%", boxShadow: "0 12px 30px -18px rgba(2,6,23,.18)", textAlign: "center" },

  /* -------- Header (optional sticky if you use it) -------- */
  header: { backgroundColor: "rgba(255,255,255,.9)", backdropFilter: "blur(8px)", borderBottom: "1px solid rgba(226,232,240,.8)", padding: "12px 0", position: "sticky", top: 0, zIndex: 50 },
  headerContent: { maxWidth: 1360, margin: "0 auto", padding: "0 24px", display: "flex", alignItems: "center", gap: 12 },
  logoContainer: { background: "linear-gradient(135deg,#2563eb,#6366f1)", padding: 10, borderRadius: 12, boxShadow: "0 8px 22px -12px rgba(37, 99, 235, .35)" },
  headerTitle: { fontSize: 18, fontWeight: 800, margin: 0, color: "#111827" },
  backButton: { display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", background: "rgba(37,99,235,.08)", color: "#2563eb", border: "1px solid rgba(37,99,235,.18)", borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: "pointer", textDecoration: "none" },

  /* -------- Page layout -------- */
  pageWrap: { width: "100%", display: "flex", justifyContent: "center" },
  fullBleed: { position: "relative", left: "50%", right: "50%", marginLeft: "-50vw", marginRight: "-50vw", width: "100vw" },
  page: {
    background:
      "radial-gradient(1000px 300px at 50% -8%, #0ea5e91A, transparent 65%)," +
      "radial-gradient(800px 220px at 95% -10%, #6366f11A, transparent 55%)",
  },

  /* Outer container width (desktop wider, tablet compact) */
  mainContent: { maxWidth: 1360, margin: "0 auto", padding: "24px 24px" },

  /* Inner readable column for header and reviews text */
  contentColumn: { width: "100%", maxWidth: 1120, margin: "0 auto", padding: "0 8px", boxSizing: "border-box" },

  /* -------- Primary grid (desktop first) -------- */
  contentGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(360px, 420px)", // left grows, right fixed-ish
    gap: 32,
    alignItems: "start",
    maxWidth: 1280,           // overall working width for the grid
    margin: "0 auto",
    width: "100%",
  },

  /* -------- Cards & sections -------- */
  profileCard: { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, boxShadow: "0 10px 28px -16px rgba(2,6,23,.16)", overflow: "hidden", marginBottom: 24 },
  profileHeader: { padding: 24, background: "#f8fafc", borderBottom: "1px solid #e5e7eb" },
  profileHeaderContent: { display: "flex", alignItems: "center", gap: 20, flexWrap: "wrap" },

  section: { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, boxShadow: "0 8px 22px -18px rgba(2,6,23,.14)", overflow: "hidden", marginBottom: 20 },
  sectionHeader: { padding: "16px 20px", background: "#f8fafc", borderBottom: "1px solid #e5e7eb", display: "flex", alignItems: "center", gap: 10 },
  sectionTitle: { fontSize: 18, fontWeight: 700, color: "#0f172a", margin: 0 },
  sectionContent: { padding: 20 },

  /* -------- Profile atoms -------- */
  avatarContainer: { position: "relative" },
  avatar: { width: 120, height: 120, borderRadius: "50%", objectFit: "cover", border: "4px solid #fff", boxShadow: "0 8px 20px -10px rgba(0,0,0,.22)" },
  avatarFallback: { width: 120, height: 120, borderRadius: "50%", background: "linear-gradient(135deg,#2563eb,#6366f1)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 28, fontWeight: 700, border: "4px solid #fff", boxShadow: "0 8px 20px -10px rgba(0,0,0,.22)" },
  verifiedBadge: { position: "absolute", bottom: 6, right: 6, background: "#10b981", color: "#fff", padding: 6, borderRadius: "50%", boxShadow: "0 2px 8px rgba(16,185,129,.35)" },

  profileInfo: { flex: 1, minWidth: 280 },
  doctorName: { fontSize: 28, fontWeight: 800, color: "#0f172a", margin: "0 0 6px 0" },
  specialty: { fontSize: 16, fontWeight: 700, color: "#2563eb", margin: "0 0 12px 0" },
  infoRow: { display: "flex", alignItems: "center", gap: 8, margin: "6px 0", fontSize: 15, color: "#475569" },

  experienceBadge: { display: "inline-flex", alignItems: "center", gap: 6, background: "#ecfdf5", color: "#065f46", padding: "8px 12px", borderRadius: 999, fontSize: 13, fontWeight: 600, marginTop: 8 },

  actionButtons: { display: "flex", gap: 10, marginTop: 16, flexWrap: "wrap" },
  primaryButton: { display: "flex", alignItems: "center", gap: 8, padding: "10px 18px", background: "linear-gradient(135deg,#2563eb,#6366f1)", color: "#fff", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: "pointer", boxShadow: "0 10px 24px -12px rgba(37,99,235,.4)", textDecoration: "none" },
  secondaryButton: { display: "flex", alignItems: "center", gap: 8, padding: "10px 18px", background: "#fff", color: "#0f172a", border: "1px solid #e5e7eb", borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: "pointer", textDecoration: "none" },

  /* -------- Text & lists -------- */
  aboutText: { fontSize: 15, lineHeight: 1.7, color: "#1f2937", marginBottom: 16 },
  infoList: { listStyle: "none", padding: 0, margin: 0 },
  infoItem: { display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: "1px solid #f3f4f6" },
  infoIcon: { width: 20, height: 20, color: "#6b7280" },
  infoLabel: { fontWeight: 700, color: "#0f172a", minWidth: 120 },
  infoValue: { color: "#475569", flex: 1 },

  tagList: { display: "flex", flexWrap: "wrap", gap: 8, marginTop: 8 },
  tag: { padding: "6px 10px", background: "#e0e7ff", color: "#1e3a8a", borderRadius: 999, fontSize: 13, fontWeight: 600 },

  /* -------- Service cards -------- */
  serviceCard: { background: "#fafafa", borderRadius: 12, padding: 16, border: "1px solid #e5e7eb", marginBottom: 12, transition: "transform .15s ease, box-shadow .15s ease" },
  serviceHeader: { display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: 8, gap: 12 },
  serviceTitle: { fontSize: 16, fontWeight: 700, color: "#0f172a", margin: 0 },
  servicePrice: { fontSize: 14, fontWeight: 800, color: "#047857", background: "#ecfdf5", padding: "6px 10px", borderRadius: 8 },
  serviceDescription: { fontSize: 14, color: "#475569", lineHeight: 1.55, marginBottom: 8 },
  serviceMeta: { display: "flex", alignItems: "center", gap: 14, fontSize: 12, color: "#94a3b8", flexWrap: "wrap" },

  /* -------- Availability & research grids -------- */
  availabilityGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12 },
  dayCard: { padding: 12, background: "#fafafa", borderRadius: 10, border: "1px solid #e5e7eb", textAlign: "center" },
  dayName: { fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 4 },
  dayTime: { fontSize: 13, color: "#475569" },

  researchGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16 },
  researchCard: { background: "#fff", borderRadius: 12, padding: 14, border: "1px solid #e5e7eb", transition: "transform .15s ease, box-shadow .15s ease", cursor: "pointer" },
  researchImage: { width: "100%", height: 160, background: "#e5e7eb", borderRadius: 8, marginBottom: 10, overflow: "hidden", position: "relative" },
  researchTitle: { fontSize: 15, fontWeight: 700, color: "#0f172a", marginBottom: 6, lineHeight: 1.35 },
  researchDescription: { fontSize: 13, color: "#475569", lineHeight: 1.55, marginBottom: 8 },
  researchMeta: { display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12, color: "#94a3b8" },
  downloadBadge: { background: "#eef2ff", color: "#1e3a8a", padding: "4px 8px", borderRadius: 999, display: "flex", alignItems: "center", gap: 4, fontWeight: 700 },

  /* -------- Uploads & misc -------- */
  uploadButton: { background: "linear-gradient(135deg,#2563eb,#6366f1)", color: "#fff", border: "none", borderRadius: 10, padding: "8px 12px", fontSize: 14, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 },
  fileHiddenInput: { display: "none" },
  spinner: { width: 18, height: 18, border: "2px solid transparent", borderTop: "2px solid #fff", borderRadius: "50%", animation: "spin 1s linear infinite" },

  /* -------- Map -------- */
  mapContainer: { width: "100%", height: 420, borderRadius: 12, overflow: "hidden", border: "1px solid #e5e7eb", background: "#f3f4f6", position: "relative" },
  mapPlaceholder: { width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#6b7280", background: "#f9fafb", padding: 12, textAlign: "center" },
  locationInfo: { background: "#fafafa", padding: 12, borderRadius: 10, border: "1px solid #e5e7eb", marginBottom: 12 },
  locationRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 },
  locationText: { fontSize: 14, color: "#0f172a", lineHeight: 1.5 },
  coordinatesText: { fontSize: 12, color: "#64748b", fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace", background: "#f3f4f6", padding: "4px 8px", borderRadius: 6, marginTop: 6 },
  directionsButton: { display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 10px", background: "#2563eb", color: "#fff", border: "1px solid #1d4ed8", borderRadius: 10, fontSize: 12, fontWeight: 700, cursor: "pointer", textDecoration: "none", marginTop: 6 },
};

export const globalStyles = `
  @keyframes spin { 0% { transform: rotate(0deg) } 100% { transform: rotate(360deg) } }

  /* Hover effects */
  .primary-button:hover { background: linear-gradient(135deg,#1d4ed8,#4338ca) !important; transform: translateY(-1px); box-shadow: 0 12px 22px -10px rgba(37,99,235,.45) !important; }
  .secondary-button:hover { background: #f9fafb !important; border-color: #2563eb !important; color: #2563eb !important; }
  .back-button:hover { background: rgba(37,99,235,.14) !important; }
  .service-card:hover { transform: translateY(-2px); box-shadow: 0 10px 22px -12px rgba(15,23,42,.2) }
  .research-card:hover { transform: translateY(-3px); box-shadow: 0 14px 26px -12px rgba(15,23,42,.22) }
  .directions-button:hover { background: #1d4ed8 !important; transform: translateY(-1px) }

  /* -------- Desktop-specific tuning (≥1280px) -------- */
  @media (min-width: 1280px) {
    .main-content { padding: 32px 24px !important; }
    .profile-header { padding: 28px !important; }
    .section-content { padding: 24px !important; }
  }

  /* -------- Tablet (≤1024px) -------- */
  @media (max-width: 1024px) {
    .content-grid { grid-template-columns: 1fr !important; gap: 20px !important; }
    .profile-header-content { flex-direction: column !important; text-align: center !important; }
    .action-buttons { justify-content: center !important; }
    .main-content { padding: 20px !important; }
  }

  /* -------- Mobile (≤768px) -------- */
  @media (max-width: 768px) {
    .availability-grid, .research-grid { grid-template-columns: 1fr !important; }
    .profile-header, .section-content { padding: 16px !important; }
    .main-content { padding: 16px !important; }
  }
`;
